import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Plane } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    if (!sessionId) {
      navigate("/login");
      return;
    }

    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        // clear the hash
        window.history.replaceState(null, "", window.location.pathname);
        setUser(data.user);
        if (!data.user.paid) navigate("/checkout");
        else if (!data.user.onboarding_complete) navigate("/onboarding");
        else navigate("/dashboard");
      } catch {
        setError("We couldn't complete sign-in. Please try again.");
        setTimeout(() => navigate("/login"), 1800);
      }
    })();
    // One-time session exchange guarded by processed ref; deps are stable.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#040406] text-white">
      <div className="h-10 w-10 rounded-xl bg-gradient-to-br from-amber-400 to-red-600 flex items-center justify-center mb-6">
        <Plane className="h-5 w-5 text-white -rotate-45" />
      </div>
      {error ? (
        <p className="text-sm text-red-400">{error}</p>
      ) : (
        <div className="flex items-center gap-2 text-white/60 text-sm">
          <Loader2 className="h-4 w-4 animate-spin" /> Signing you in…
        </div>
      )}
    </div>
  );
}
